import { TrendingUp, TrendingDown } from "@mui/icons-material"
import { Body2, H5, Body3, H4 } from "../../themes/typography"
import "../../styles/components/StatisticsCard.css"

export default function StatisticsCard({
    name = "Statistics",
    value = "1,250",
    description = "Total Attendees",
    trendValue = "+8.4%",
    trendType = "up", // "up" or "down"
    shouldShowDescription = false
}) {
    return (
        <div className="statistics-card-1-container">

            <div className="statistics-card-1-wrapper">

                <div className="statistics-card-1-left">

                    <div className="statistics-card-1-title">
                        <Body3 fontWeight={400}>
                            {name}
                        </Body3>
                    </div>

                    <div className="statistics-card-1-value">
                        <H4 fontWeight={700} color="var(--secondary-color)">
                            {value}
                        </H4>
                        {shouldShowDescription && (
                            <Body2 fontWeight={400} color="var(--quaternary-color)">
                                {description}
                            </Body2>
                        )}
                    </div>

                </div>
                <div className="statistics-card-1-right">

                    <div className="statistics-card-1-trend">
                        <div className="statistics-card-1-icon">

                            {trendType === "up"
                                ? <TrendingUp color="success" />
                                : <TrendingDown color="error" />
                            }
                        </div>
                        <div className="statistics-card-1-trend-value">
                            <Body3
                                fontWeight={500}
                                // color={`"var(--success-secondary-color)"`}
                                color={trendType === "up"
                                    ? "var(--success-secondary-color)"
                                    : "var(--error-secondary-color)"
                                }
                            >
                                {trendValue}
                            </Body3>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}